import React from 'react'

export type ButtonProps = {
    children: React.ReactNode
    variant?: 'primary' | 'secondary' | 'outlined' | 'ghost' | 'text' | 'contained'
    size?: 'small' | 'medium' | 'large'
    onClick?: (params?: any) => (void | Promise<void>)
    type?: 'button' | 'submit'
    disabled?: boolean
    color?: 'primary' | 'secondary'
    className?: string // For additional custom styles
    id?: string // For additional custom styles
};

export const Button: React.FC<ButtonProps> = ({
    children,
    variant = 'primary',
    size = 'medium',
    type = 'button',
    color = 'primary', // todo implement color
    onClick,
    id,
    disabled = false,
    className = '',
}) => {
    // Map DaisyUI classes to props
    const baseClass = 'btn';
    const variantClass = {
        primary: 'btn-primary',
        secondary: 'btn-secondary',
        outlined: 'btn-outline',
        contained: 'btn-outline',
        ghost: 'btn-ghost',
        text: 'btn-ghost',
    }[variant];
    const sizeClass = {
        small: 'btn-sm',
        medium: '',
        large: 'btn-lg',
    }[size];

    return (
        <button
            id={id}
            type={type}
            className={`${baseClass} ${variantClass} ${sizeClass} ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
}